import React from 'react';
import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import colors from '../colors';

const StyledHeaderRow = styled(Row)`
    background-color: ${colors.bgHeaderCol};
    padding: 12px 16px;

    & .ant-col {
        font-size: 18px;
    }
`;

interface HeaderRowProps {
  leftSideText: string;
  rightSideText: string;
  children: React.ReactNode;
}

function HeaderRow({ leftSideText, rightSideText, children }: HeaderRowProps) {

    return (
        <>
            <StyledHeaderRow>
                <Col span={20}>{leftSideText}</Col>
                <Col span={4}>{rightSideText}</Col>
            </StyledHeaderRow>
            <Row>
                {children}
            </Row>
        </>
    );
}

HeaderRow.propTypes = {
  leftSideText: PropTypes.string,
  rightSideText: PropTypes.string,
};

HeaderRow.defaultProps = {
  leftSideText: '',
  rightSideText: ''
};

/** @component */
export default HeaderRow;
